export default __webpack_public_path__ + "fonts/custom-list.svg";